import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import SuperAdminSidebar, { SuperAdminMobileHeader } from './SuperAdminSidebar';
import './SuperAdminLayout.scss';

const SuperAdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="superadmin-layout">
      <SuperAdminMobileHeader onMenuClick={() => setSidebarOpen(true)} />
      <SuperAdminSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <main className="superadmin-main">
        <div className="superadmin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default SuperAdminLayout;